module.exports = __webpack_public_path__ + "static/img/call-pass-off.e3fe6210.png";